"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawInvitationRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.WithdrawInvitationRequestStruct = (0, superstruct_1.type)({
    organisationId: (0, superstruct_1.string)(),
    inviteId: (0, superstruct_1.string)(),
});
//# sourceMappingURL=WithdrawInvitationRequest.js.map